export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8047.de3dbac0.jpg";